import $ from "jquery";

$(document).ready(function () {
    var bpDiv = document.getElementById('bp_div');
    var bpError = document.getElementById('bp_error');
    if(!bpDiv && !bpError) {
        $("#three-quarters-loader-position, #three-quarters-loader-container").hide();
    } else {
        var callback = function() {
            $("#three-quarters-loader-position, #three-quarters-loader-container").hide();
        };

        var observer = new MutationObserver(callback);
        observer.observe(bpDiv, {childList: true});
        observer.observe(bpError, {attributes: true});
    }
})
